import type { TextInputContainerProps } from './TextInputContainer.tsx';
import clsx from 'clsx';
import { TextInputContainer } from './TextInputContainer.tsx';

export interface MultilineTextInputProps
  extends
    Pick<
      React.ComponentPropsWithRef<'textarea'>,
      | 'autoFocus'
      | 'disabled'
      | 'id'
      | 'name'
      | 'onBlur'
      | 'onChange'
      | 'onFocus'
      | 'maxLength'
      | 'placeholder'
      | 'ref'
      | 'required'
      | 'rows'
      | 'value'
    >,
    Pick<TextInputContainerProps, 'cornerText' | 'error' | 'helpText' | 'label' | 'rounded'> {}

export function MultilineTextInput(props: MultilineTextInputProps) {
  const {
    autoFocus,
    cornerText,
    disabled,
    error,
    helpText,
    label,
    name,
    placeholder,
    required,
    rounded,
    value,
    ...otherProps
  } = props;

  return (
    <TextInputContainer
      cornerText={cornerText}
      disabled={disabled}
      error={error}
      label={label}
      helpText={helpText}
      rounded={rounded}
    >
      <textarea
        {...otherProps}
        autoFocus={autoFocus}
        className={clsx(
          'block w-full grow resize-none appearance-none border-0 px-3 py-2 focus-within:outline-hidden focus:ring-0 sm:text-sm',
          disabled && 'text-gray-400 placeholder-gray-300',
          error && 'placeholder-red-300',
          !disabled && !error && 'placeholder-gray-400'
        )}
        data-autofocus={autoFocus}
        disabled={disabled}
        name={name}
        placeholder={placeholder}
        required={required}
        value={value}
      />
    </TextInputContainer>
  );
}
